// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"fe48d871","117":"c643d16a","145":"f5234060"}[chunkId] + ".chunk.css";
};